<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 8.6C14 7.7176 13.2824 7 12.4 7H12V5C12 2.7944 10.2056 1 7.99995 1C5.79435 1 3.99995 2.7944 3.99995 5L3.99995 7H3.6C2.7176 7 2 7.7176 2 8.6L2 13.4001C2 14.2825 2.7176 15.0001 3.6 15.0001H12.4C13.2824 15.0001 14 14.2825 14 13.4001L14 8.6ZM6 5C6 3.6768 6.89543 3 8 3C9.10457 3 10 3.6768 10 5V7H6L6 5Z"
    fill="currentColor"
  />
</svg>
